<template>
    <div>
        <froala
            data-testid="static-page-froala-wrapper-textarea"
            class="static-page-froala-wrapper-textarea"
            v-show="launchFroala"
            :tag="'textarea'"
            :config="froalaConfig"
            v-model.trim="section.content"
            :id="`section-${section.ident}`"
            v-if="section.type === 'wysiwyg'"
        />
    </div>
</template>

<script>
export default {
  props: {
    froalaConfig: {
      type: Object
    },
    section: {
      type: [Object, null, String]
    },
    launchFroala: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style>
    .froala {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
